var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionEmotionQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionEmotionQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [BEGINNING_STAGE];
		}

		if ((this.props.level != "3" && !answers[BEGINNING]) || (this.props.level == "3" && !answers[RISING_ACTION])) {
			return [BEGINNING_STAGE];
		}

		if ((this.props.level == "2" && !answers[MIDDLE]) || (this.props.level == "3" && !answers[CLIMAX])) {
			return [MIDDLE_STAGE];
		}

		if (this.props.level != "3") {
			if (!answers[END]) {
				return [END_STAGE];
			} else if (this.props.level == "1") {
				return [END_STAGE, true];
			}
		} else {
			if (!answers[FALLING_ACTION]) {
				return [FALLING_ACTION_STAGE];
			}
			if (!answers[RESOLUTION]) {
				return [END_STAGE];
			}
		}

		if (!answers[OVERALL]) {
			return [OVERALL_STAGE];
		} else {
			return [OVERALL_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var beginningKey = this.props.level == "3" ? RISING_ACTION : BEGINNING;
		var beginningDisplay = (
			<div>
				{ this.props.getTextF("label1", BEGINNING_STAGE) }
				{ this.props.renderMultiSelectF("choices1", BEGINNING_STAGE, beginningKey, 1) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0 && this.props.level != "1") {
			var middleKey = this.props.level == "3" ? CLIMAX : MIDDLE;
			var middleDisplay = (
				<div>
					{ this.props.getTextF("label1", MIDDLE_STAGE) }
					{ this.props.renderMultiSelectF("choices1", MIDDLE_STAGE, middleKey, 1) }.
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1 && this.props.level == "3") {
			var fallingActionDisplay = (
				<div>
					{ this.props.getTextF("label1", FALLING_ACTION_STAGE) }
					{ this.props.renderMultiSelectF("choices1", FALLING_ACTION_STAGE, FALLING_ACTION, 1) }.
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var endKey = this.props.level == "3" ? RESOLUTION : END;
			var endDisplay = (
				<div>
					{ this.props.getTextF("label1", END_STAGE) }
					{ this.props.renderMultiSelectF("choices1", END_STAGE, endKey, 1) }.
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 3) {
			var overallDisplay = (
				<div>
					{ this.props.getTextF("label1", OVERALL_STAGE) }
					{ this.props.renderMultiSelectF("choices1", OVERALL_STAGE, OVERALL, 1) }.
				</div>
			);
		}

		return (
			<div>
				{ beginningDisplay }
				{ middleDisplay }
				{ fallingActionDisplay }
				{ endDisplay }
				{ overallDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionEmotionQuestion.STEM = "femo";

// stages
var BEGINNING_STAGE = "beginning";
var MIDDLE_STAGE = "middle";
var FALLING_ACTION_STAGE = "fallingaction";
var END_STAGE = "end";
var OVERALL_STAGE = "overall";

var STAGES = [
	BEGINNING_STAGE, MIDDLE_STAGE, FALLING_ACTION_STAGE, END_STAGE, OVERALL_STAGE
];

// answer keys
var BEGINNING = "beginning_feeling";
var MIDDLE = "middle_feeling";
var END = "end_feeling";
var RISING_ACTION = "rising_action_feeling";
var CLIMAX = "climax_feeling";
var FALLING_ACTION = "falling_action_feeling";
var RESOLUTION = "resolution_feeling";
var OVERALL = "overall_feeling";

FictionEmotionQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionEmotionQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionEmotionQuestion.js